var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.859 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26128",
    d: "M30.783 12.114a.576.576 0 0 0-.2-.243 3.848 3.848 0 0 1-1.464-3.3 4.4 4.4 0 0 1 1.536-2.9.571.571 0 0 0 0-.83 5.827 5.827 0 0 0-3.821-1.408 5.157 5.157 0 0 0-2.857.866 5.111 5.111 0 0 0-6.479.649 5.331 5.331 0 0 0-1.521 3.87 9.076 9.076 0 0 0 2.867 6.409A2.843 2.843 0 0 0 20.8 16h6.263a2.846 2.846 0 0 0 2.08-.9 8.929 8.929 0 0 0 1.273-1.757c.505-.914.441-1.057.367-1.229zm-2.474 2.21a1.7 1.7 0 0 1-1.243.534H20.8a1.7 1.7 0 0 1-1.174-.465 7.939 7.939 0 0 1-2.511-5.606 4.179 4.179 0 0 1 1.189-3.038 3.915 3.915 0 0 1 2.811-1.176h.056a3.961 3.961 0 0 1 2.444.877.571.571 0 0 0 .714 0 3.96 3.96 0 0 1 2.5-.877 5.046 5.046 0 0 1 2.571.739 5.055 5.055 0 0 0 .156 7.211 7.559 7.559 0 0 1-1.251 1.8zM23.993 2.143A2.857 2.857 0 0 1 26.762 0h.071a.571.571 0 1 1 0 1.143h-.071A1.714 1.714 0 0 0 25.1 2.429a.572.572 0 0 1-1.107-.286z",
    transform: "translate(-15.974)",
    style: {
      fill: "#0c1135"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.3cdd31163339af0bf29cdac8ba2d6243.svg";
export { ForwardRef as ReactComponent };